import http from "@/http/aisea/axios";
import { MULTIPART } from "@/config/";
const resource = "/hull_insurance/enterprises/claim_reports";

export default {
  fetch(query) {
    return http.get(`${resource}`, { params: query });
  },
  fetchVessels() {
    return http.get(`${resource}/search-parameter`);
  },
  fetchInputSituation(claimReportId) {
    return http.get(`${resource}/${claimReportId}/input_situation`);
  },
  delete(id) {
    return http.delete(`${resource}/${id}`);
  },
  add(body) {
    return http.post(`${resource}`, body);
  },
  addReportFile(filename, body) {
    return MULTIPART.post(`${resource}/files/${filename}`, body);
  },
  addSummaryFile(reportId, overviewId, body) {
    return MULTIPART.post(
      `${resource}/${reportId}/overviews/${overviewId}/files`,
      body
    );
  },
  deleteSummaryFile(reportId, overviewId, body) {
    return http.delete(
      `${resource}/${reportId}/overviews/${overviewId}/files`,
      { data: body }
    );
  },
  getSummaryFile(reportId, overviewId, filename) {
    return http.get(
      `${resource}/${reportId}/overviews/${overviewId}/files/${filename}`,
      {
        responseType: "arraybuffer", // レスポンスをバイナリデータとして取得
      }
    );
  },
  getAllSummaryFile(reportId, overviewId) {
    return http.get(`${resource}/${reportId}/overviews/${overviewId}/files`);
  },

  getOverviews(reportId) {
    return http.get(`${resource}/${reportId}/overviews`);
  },
  getStaffs(reportId) {
    return http.get(`${resource}/${reportId}/staffs`);
  },
  getClaimTypes(reportId) {
    return http.get(`${resource}/${reportId}/claim_types`);
  },
  updateOverviews(reportId, overviewId, body) {
    return http.put(`${resource}/${reportId}/overviews/${overviewId}`, body);
  },
  updateStaffs(reportId, staffId, body) {
    return http.put(`${resource}/${reportId}/overviews/${staffId}`, body);
  },
  //update (id, payload) { },
};
